import React from 'react';
import { Label } from '@common/components';
import { Stack } from '@common/components/Stack';

export type ReadOnlyTextFieldProps = {
  label: string;
  displayText: string;
};

export const ReadOnlyTextField: React.FC<ReadOnlyTextFieldProps> = ({ label, displayText }) => (
  <Stack gap={1}>
    <Label isRequired>{label}</Label>
    <p>{displayText}</p>
  </Stack>
);
